import axios from "../axios";

const create = (data) => axios.post(`/employees`, data);
const getCompanyEmployee = (companyId) => axios.get(`/employees/company/${companyId}`);
const update = (employeeId, data) =>
    axios.put(`/employees/${employeeId}`, data);
const remove = (employeeId) => axios.delete(`/employees/${employeeId}`);
const getOrganizationEmployee = (organizationId) => axios.get(`/employees/organization/${organizationId}`);

const employeeService = {
    create,
    remove,
    update,
    getCompanyEmployee,
    getOrganizationEmployee,
};

export default employeeService;
